export class RechargeBuildYourOwnSet extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    console.log('RechargeBuildYourOwnSet initialized');

      // Define the messages for each header
      this.customMessages = {
        'Sleep Support': window.rechargeBundleData.sleep_bundle_subheading,
        'Stress Relief & Calm Support': window.rechargeBundleData.calm_bundle_subheading,
        'Daily Care Support': window.rechargeBundleData.daily_wellness_bundle_subheading,
        'Energy & Recovery Support': window.rechargeBundleData.recovery_energy_bundle_subheading,
        'Focus & Cognitive Health Support': window.rechargeBundleData.focus_bundle_subheading
      };

    // Start the injection process
    this.injectBelowHeaders();
    this.setupObserver();
    // this.setupStickyBar();

  }

    // Function to find headers and inject messages
    injectBelowHeaders() {
      const headers = document.querySelectorAll('.rb-section-header');
  
      headers.forEach(header => {
        const title = header.textContent.trim();
        const message = this.customMessages[title];
  
        // Skip if no message or already injected
        const alreadyInjected = header.nextElementSibling?.classList?.contains('custom-injected-msg');
        if (!message || alreadyInjected) return;
  
        // Create the injected div
        const infoDiv = document.createElement('div');
        infoDiv.className = 'custom-injected-msg';
        infoDiv.textContent = message;
        infoDiv.style.cssText = `
          margin-top: 8px;
          margin-bottom: 8px;
          color: #333;
          font-size: 14px;
        `;
  
        // Insert it right after the header
        header.insertAdjacentElement('afterend', infoDiv);
      });
    }

  // Setup observer for dynamic content
  setupObserver() {
    this.observer = new MutationObserver(() => {
      this.injectBelowHeaders();
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Setup sticky bar functionality
  setupStickyBar() {
    const waitForStickyBar = () => {
      const stickyBar = document.querySelector('.status-bar-sign-up');
      const triggerElement = document.querySelector('.announcement');

      if (!stickyBar || !triggerElement) {
        console.warn('Missing sticky bar or trigger element');
        return;
      }

      // Use IntersectionObserver to track visibility of the trigger element
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Element is visible in the viewport
              stickyBar.classList.remove('sticky-active');
              console.log('announcement visible → sticky-inactive');
            } else {
              // Element has scrolled out of view
              stickyBar.classList.add('sticky-active');
              console.log('announcement hidden → sticky-active');
            }
          });
        },
        {
          root: null, // viewport
          threshold: 0.01 // treat as visible when 1% of it is visible
        }
      );

      this.intersectionObserver.observe(triggerElement);
    };

    // MutationObserver to wait until sticky bar exists
    this.domObserver = new MutationObserver(() => {
      const stickyBarExists = document.querySelector('.status-bar-sign-up');
      const announcementExists = document.querySelector('.announcement');

      if (stickyBarExists && announcementExists) {
        waitForStickyBar();
        this.domObserver.disconnect();
      }
    });

    this.domObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Clean up when element is removed
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    if (this.domObserver) {
      this.domObserver.disconnect();
    }
  }
}